module.exports = __webpack_public_path__ + "static/media/learn.5523fcc8.png";